// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Buhta_landing__EventHandlers from "../../../util/EventHandlers.js";
import * as Buhta_landing__Link from "../../../components/html/Link.js";
import * as Buhta_landing__Route from "../../../Route.js";
import * as Cn from "../../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as Stdlib__List from "melange/list.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

const languages_0 = {
  code: /* Kk */ 2,
  name: "Қазақша",
  icon: JsxRuntime.jsx("img", {
    className: "mr-3 inline",
    src: StaticAsset.src("/static/icons/kazakhstan-round.svg")
  })
};

const languages_1 = {
  hd: {
    code: /* En */ 0,
    name: "English",
    icon: JsxRuntime.jsx("img", {
      className: "mr-3 inline",
      alt: "uk",
      src: StaticAsset.src("/static/icons/uk.svg")
    })
  },
  tl: {
    hd: {
      code: /* Ru */ 1,
      name: "Русский",
      icon: JsxRuntime.jsx("img", {
        className: "rounded-full mr-3 inline",
        src: StaticAsset.src("/static/icons/russia.svg")
      })
    },
    tl: /* [] */ 0
  }
};

const languages = {
  hd: languages_0,
  tl: languages_1
};

function FooterLanguageSelect(Props) {
  const match = React.useState(function () {
    return false;
  });
  const setDropdownShown = match[1];
  const dropdownShown = match[0];
  const activatorRef = React.useRef(null);
  const dropdownRef = React.useRef(null);
  Buhta_landing__EventHandlers.useClickOutside(dropdownRef, activatorRef, (function (param) {
    Curry._1(setDropdownShown, (function (param) {
      return false;
    }));
  }));
  const onClickedInside = function (ev) {
    ev.stopPropagation();
  };
  const country = Buhta_landing__Route.getCountry(undefined);
  const language = Buhta_landing__Route.getLanguage(undefined);
  let currentLanguage;
  try {
    currentLanguage = Stdlib__List.find((function (l) {
      return l.code === language;
    }), languages);
  }
  catch (exn){
    currentLanguage = Stdlib__List.hd(languages);
  }
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsxs("div", {
        ref: activatorRef,
        children: [
          JsxRuntime.jsx("img", {
            className: "inline mr-1",
            src: StaticAsset.src("/static/icons/language.svg")
          }),
          JsxRuntime.jsx("span", {
            children: currentLanguage.name,
            className: "caption-medium text-primary select-none"
          })
        ],
        className: "cursor-pointer",
        onClick: (function (param) {
          Curry._1(setDropdownShown, (function (param) {
            return !dropdownShown;
          }));
        })
      }),
      JsxRuntime.jsx("div", {
        ref: dropdownRef,
        children: Belt__Belt_List.toArray(Stdlib__List.mapi((function (index, l) {
          const Key = "country_dropdown_" + String(index);
          return JsxRuntime.jsxs(Buhta_landing__Link.make, {
            route: {
              TAG: /* Landing */ 0,
              _0: country,
              _1: l.code,
              _2: /* Home */ 0
            },
            className: "paragraph-small text-black-landing py-2 px-4 block cursor-pointer transition-all duration-200 ease-in-out hover:bg-bg",
            onLinkClicked: (function (param) {
              Curry._1(setDropdownShown, (function (param) {
                return false;
              }));
            }),
            children: [
              l.icon,
              l.name
            ]
          }, Key);
        }), languages)),
        className: Cn.fromList({
          hd: "absolute bottom-8 -left-7 w-40 bg-white shadow-dropdown rounded-md py-4",
          tl: {
            hd: dropdownShown ? "block" : "hidden",
            tl: /* [] */ 0
          }
        })
      })
    ],
    className: "ml-4 relative",
    onClick: onClickedInside
  });
}

const make = FooterLanguageSelect;

export {
  languages,
  make,
}
/* languages Not a pure module */
